import React, {useState, useEffect} from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  SlTabGroup,
  SlTab,
  SlTabPanel,
} from "@shoelace-style/shoelace/dist/react";
import DailyVsEenadu from "./DailyVsEenadu";
import EffortAnalysisReports from "./EffortAnalysisReports";
import MonthlyRevenue from "./MonthlyRevenue";
import MonthlyVsEenadu from "./MonthlyVsEenadu";
import DailyMissing from "./DailyMissing";
import OverallRevenue from "./OverallRevenue";
import SalesPersonReports from "./SalesPersonReports";
import AccountConversionRollingAverage from "./AccountConversionRollingAverage";

function SalesReports() {
  const { tab } = useParams();
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = useState(tab || "dailyvseenadu");

  useEffect(() => {
    if (tab && tab !== currentTab) setCurrentTab(tab);
  }, [tab]);

  const handleTabChange = (e) => {
    const name = e.detail.name;
    setCurrentTab(name);
    navigate(`/home/salesreports/${name}`, { replace: true });
  };

  return (
    <>
      <h5>Sales Reports</h5>
      <SlTabGroup onSlTabShow={handleTabChange}>
        <SlTab slot="nav" panel="dailyvseenadu" active={currentTab === 'dailyvseenadu'}>Daily vs Eenadu</SlTab>
        <SlTab slot="nav" panel="monthlyvseenadu" active={currentTab === 'monthlyvseenadu'}>Monthly Vs Eenadu</SlTab>
        <SlTab slot="nav" panel="effortanalysis" active={currentTab === 'effortanalysis'}>Effort Analysis</SlTab>
        <SlTab slot="nav" panel="dailymissing" active={currentTab === 'dailymissing'}>Daily Missing</SlTab>
        <SlTab slot="nav" panel="overallrevenue" active={currentTab === 'overallrevenue'}>Overall Revenue</SlTab>
        <SlTab slot="nav" panel="monthlyrevenue" active={currentTab === 'monthlyrevenue'}>Monthly Revenue Report</SlTab>
        <SlTab slot="nav" panel="saleswise" active={currentTab === 'saleswise'}>Sales Person Wise</SlTab>
        <SlTab slot="nav" panel="rollingaverage" active={currentTab === 'rollingaverage'}>12 Month Rolling Average</SlTab>

        <SlTabPanel name="dailyvseenadu">
            {currentTab === 'dailyvseenadu' && <DailyVsEenadu />}
        </SlTabPanel>
        <SlTabPanel name="effortanalysis">
          {currentTab === 'effortanalysis' && <EffortAnalysisReports />}
          </SlTabPanel>
        <SlTabPanel name="monthlyrevenue">
          {currentTab === 'monthlyrevenue' && <MonthlyRevenue />}
          </SlTabPanel>
          <SlTabPanel name="monthlyvseenadu">
            {currentTab === 'monthlyvseenadu' && <MonthlyVsEenadu />}
          </SlTabPanel>
        <SlTabPanel name="dailymissing">
          {currentTab === 'dailymissing' && <DailyMissing/>}
        </SlTabPanel>
        <SlTabPanel name="overallrevenue">
            {currentTab === 'overallrevenue' && <OverallRevenue />}
        </SlTabPanel>
        <SlTabPanel name="saleswise">
            {currentTab === 'saleswise' && <SalesPersonReports />}
          </SlTabPanel>
        <SlTabPanel name="rollingaverage">
          {currentTab === 'rollingaverage' && <AccountConversionRollingAverage /> }
        </SlTabPanel>
      </SlTabGroup>
    </>
  );
}

export default SalesReports;
